export const INIT = 'app/ResetPassword/INIT';

export const SUBMIT = 'containers/ResetPassword/SUBMIT';
export const SUBMIT_SUCCESS = 'containers/ResetPassword/SUBMIT_SUCCESS';
export const SUBMIT_FAILED = 'containers/ResetPassword/SUBMIT_FAILED';

export const RESET_DIALOG = 'app/ForgotPassword/RESET_DIALOG';
